<div class="md-block" *ngIf="data.value">
	<div class="md-block-icon" [ngClass]="data.color">
		{{ data.letter }}
	</div>
	{{ data.value }}
</div>
